/* eslint-disable @next/next/no-img-element -- Bypassing the rule because we don't want to cache the image on the server */
import React, { useState } from 'react';
import { CountryCode, CountryCodeList } from 'types/countries';
import styles from './style.module.scss';

import type Listing from 'data/listing';
import { mlsProviderIds } from 'constants/mlsProviderIds';
import { useTranslation } from 'next-i18next';
import { Namespaces } from 'types/locales';
import { LOCALE_COMMON_PATHS } from 'types/locales';
type BrokerageLogosProps = {
  providerId: Listing['providerId'];
  countryCode: CountryCode;
  creaUrl?: string;
};

function CreaLogo({ url }: { url: string }) {
  const { t } = useTranslation(Namespaces.COMMON);

  const targetUrl = url ? url.startsWith('https://') ? url : `https://${url}` : 'https://www.realtor.ca/en';
  return (
    <a href={targetUrl} target="_blank" rel="noreferrer" className={styles['crea-logo']}>
      <div style={{ width: '3.6rem', maxWidth: '3.6rem', height: 'auto', marginRight: '1rem' }}>
        <img
          src="/next/assets/images/powered_by_realtor.svg"
          alt={
            t(LOCALE_COMMON_PATHS.PROVIDER_DISCLAIMER_POWERED_BY_REALTOR,
              { defaultValue: 'Powered by: REALTOR.ca' })
          }
          width={'100%'}
          height={'auto'}
        />
      </div>
    </a>
  );
}

function ProviderLogo({ providerId }: { providerId: number }) {
  const [hasError, setHasError] = useState(false);

  if (hasError) return null;

  return (
    <div style={{ width: '7.5rem', maxWidth: '7.5rem', height: 'auto' }}>
      <img src={`https://zoocasa.s3.amazonaws.com/provider-logos/PROV_LOGO_${providerId}.png`} alt="Provider logo" width="100%" height="auto" onError={() => setHasError(true)} />
    </div>);
}

function RealtorLogo() {
  return (
    <div style={{ width: '2rem', maxWidth: '2rem', height: 'auto' }}>
      <img src="/assets/images/listing-page/logo-realtor.svg" alt="Realtor logo" width="100%" height="auto" />
    </div>
  );
}

function MLSLogo() {
  return (
    <div style={{ width: '3.6rem', maxWidth: '3.6rem', height: 'auto', marginLeft: '1rem' }}>
      <img src="/assets/images/listing-page/logo-mls.svg" alt="MLS logo" width="100%" height="auto" />
    </div>
  );
}

export default function BrokerageLogos({ providerId, countryCode, creaUrl }: BrokerageLogosProps) {
  const isAmericanListing = countryCode == CountryCodeList.UNITED_STATES;
  const isCanadianListing = countryCode == CountryCodeList.CANADA;
  const showProviderLogo = isAmericanListing
    || providerId === mlsProviderIds.nsaor
    || providerId === mlsProviderIds.centris
    || providerId === mlsProviderIds.cnnalar
    || providerId === mlsProviderIds.cnnalar_v;

  return (
    <div className={styles.component}>
      <div className={styles['logos-row']}>
        {showProviderLogo &&
          <ProviderLogo providerId={providerId} />
        }
        {isCanadianListing &&
          <>
            { creaUrl ?
              <CreaLogo url={creaUrl} /> :
              <RealtorLogo />
            }
            <MLSLogo />
          </>
        }
      </div>
    </div>
  );
}
